import React from "react";
import * as styles from "./style.mod.scss";
import translations from "locales";
import GiftIcon from "assets/svgs/geschenk.svg";
import Heart from "assets/images/red-heart.svg"; 
// import Pot from "assets/images/kochtopf.png";

const calculateDiscountRange = (tieredDiscount, key) => {
  const figures = tieredDiscount.map(item => item[key] || 0);
  return {
    min: Math.min(...figures),
    max: Math.max(...figures),
  };
};


const AdditionalText = ({ data, total }) => {
  const cartLoc = translations.cart;
  const nextLevelIndex = data.tieredDiscount.findIndex(level => total < level.price);
  if (nextLevelIndex === -1) {
    return <p className={styles.additionalText}><GiftIcon />{cartLoc.additionalText}</p>;
  }

  const additionalAmountNeeded = data.tieredDiscount[nextLevelIndex].price - total;

  return (
    <p className={styles.text}>
      <GiftIcon /> <strong>{`${cartLoc.only} ${additionalAmountNeeded}${cartLoc?.currency}`}</strong>{cartLoc.offer}
    </p>
  );
};


const ProgressBar = ({ lineWidth, children }) => (
  <div className={styles.progress}>
    <div className={styles.progressLine}>
      <div
        className={styles.filledProgressLine}
        style={{
          width: lineWidth,
          transform: "translate3d(0px, 0px, 0px)",
          transition: "transform .6s ease-out 0s, width .6s ease-out 0s",
        }}
      >
        <span className={styles.point}></span>
      </div>
      <div className={styles.progressLineBody}>{children}</div>
    </div>
  </div>
);


const TieredDiscount = ({ item }) => {
  const cartLoc = translations.cart;


  return (
    <div key={item.key} className={styles.container}>
      <div className={styles.discountContainer}>
        <img src={Heart} alt="heart" />
        <p className={styles.discount}>
          {item?.discount}%
        </p>
      </div>
      <div className={styles.priceContainer}>
        <div className={styles.pointsContainer}>
          <p className={styles.points}>.</p>
          <p className={styles.points}>.</p>
          <p className={styles.points}>.</p>
        </div>
        <p className={styles.price}>
          {item.price}{cartLoc?.currency}
        </p>
      </div>
    </div>
  );
};

const TieredDiscountBar = ({ data, total, discount, code }) => {

  if (!data?.showTieredDiscountBar || discount?.toLowerCase() !== code?.toLowerCase()) {
    return null;
  }

  const { min: minPrice, max: maxPrice } = calculateDiscountRange(data.tieredDiscount, "price");
  let lineWidth = `${(total / maxPrice) * 100}%`;
  if (total < minPrice) {
    lineWidth = "0";
  } else if (total >= maxPrice) {
    lineWidth = "100%";
  }

  return (
    <div className={styles.progressBar}>
      <div className={styles.progressBarBody}>
        <div className={styles.progressBarMessage}>
          <AdditionalText data={data} total={total} />
        </div>
        <div className={styles.body}>
          <ProgressBar lineWidth={lineWidth}>
            {data?.tieredDiscount?.map((item, index) => (
              <TieredDiscount item={item} key={item?.key} index={index} total={total}/>
            ))}
          </ProgressBar>
        </div>
      </div>
    </div>
  );
};

export default TieredDiscountBar;